<template>
  <div>
    <guest > </guest> 
  </div>
</template>
<script>
import guest from '../../tongyong/yuangong.vue'
 
export default {

  components: {
    guest: guest 
  },

  data() {
    return {
      // 获取用户列表参数
      
    };
  },
  props: [],
 
  watch: {
 
  },
  created() {
 
  },
  mounted() {
 
  }
}
</script>
